import { axios } from '@/utils/request'

const api = {
  centerList: '/wyhadminapi/examecenter/centerList',
    centerDetail: '/wyhadminapi/examecenter/centerDetail',
    editCenter: '/wyhadminapi/examecenter/editCenter',
    applyList: '/wyhadminapi/qcxj/applyList',
    applyDetail: '/wyhadminapi/qcxj/applyDetail',
    editApply: '/wyhadminapi/qcxj/editApply',
    editApplyScoreStatus: '/wyhadminapi/qcxj/editApplyScoreStatus',
    applyMemberList: '/wyhadminapi/qcxj/applyMemberList',
    centerDownloadUrl: '/wyhadminapi/examecenter/centerDownloadUrl',
    applyDelete: '/wyhadminapi/qcxj/applyDelete',
    getSetting: '/wyhadminapi/qcxj/getSetting',
    setSetting: '/wyhadminapi/qcxj/setSetting',
    getApplyOrderDetail: '/wyhadminapi/qcxj/applyOrderDetail',
    editApplyOrder: '/wyhadminapi/qcxj/editApplyOrder',
    getApplyUserDetail: '/wyhadminapi/qcxj/memberDetail',
    editApplyUser: '/wyhadminapi/qcxj/applyMemberEdit',
    refreshOrder: '/wyhadminapi/qcxj/refreshOrder',
}

export default api

export function getCenterList(parameter) {
  return axios({
    url: api.centerList,
    method: 'get',
    params: parameter
  })
}

export function getCenterDetail(parameter) {
  return axios({
    url: api.centerDetail,
    method: 'get',
    params: parameter
  })
}
export function editCenter(parameter) {
  return axios({
    url: api.editCenter,
    method: 'post',
    data: parameter
  })
}

export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function getApplyMemberList(parameter) {
    return axios({
        url: api.applyMemberList,
        method: 'get',
        params: parameter
    })
}
export function getCenterDownloadUrl(parameter) {
    return axios({
        url: api.centerDownloadUrl,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}
export function editApplyScoreStatus(parameter) {
    return axios({
        url: api.editApplyScoreStatus,
        method: 'post',
        data: parameter
    })
}
export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}
export function setSetting(parameter) {
    return axios({
        url: api.setSetting,
        method: 'post',
        data: parameter
    })
}
export function getSetting(parameter) {
    return axios({
        url: api.getSetting,
        method: 'post',
        data: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function getApplyUserDetail(parameter) {
    return axios({
        url: api.getApplyUserDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyUser(parameter) {
    return axios({
        url: api.editApplyUser,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}
